import React from "react";

function SkeletonCard() {
  return (
    <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="h-72 animate-pulse bg-slate-200 dark:bg-white/10" />

      <div className="space-y-4 p-5">
        <div className="h-5 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        <div className="h-4 w-1/2 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />

        <div className="grid gap-2 sm:grid-cols-2">
          <div className="h-11 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
          <div className="h-11 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
        </div>
      </div>
    </div>
  );
}

function TechniquesSkeleton() {
  return (
    <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
}

export default TechniquesSkeleton;